import request from '@/utils/request'

// 近六月企业趋势
export function getCompanyList() {
  return request({
    url: '/forklift/dashboard/getSixMonthCompanyCount',
    method: 'get'
  })
}

// 最近六个月截止月底的叉车数量
export function getCarList() {
  return request({
    url: '/forklift/dashboard/getSixMonthCarCount',
    method: 'get'
  })
}

// 概览
export function getBaseInfo() {
  return request({
    url: '/forklift/dashboard/overview',
    method: 'get'
  })
}

// 车辆数排名
export function getCarSortList() {
  return request({
    url: '/forklift/dashboard/getCompanyCarCount',
    method: 'get'
  })
}

// 设备状态
export function getCarStatus() {
  return request({
    url: '/forklift/dashboard/deviceStatus',
    method: 'get'
  })
}

// 预警记录
export function getWarnList() {
  return request({
    url: '/forklift/dashboard/getWarnEventRecords',
    method: 'get'
  })
}

// 预警统计
export function getWarnAnay() {
  return request({
    url: '/forklift/dashboard/warnStatistics',
    method: 'get'
  })
}

// 地级市
export function getCityList() {
  return request({
    url: '/forklift/dashboard/selectCarCountInCity',
    method: 'get'
  })
}

// 地级市
export function getAreaList() {
  return request({
    url: '/forklift/dashboard/selectCarCountInArea',
    method: 'get'
  })
}

// 获取分页预警记录
export function getWarnPage(params) {
  return request({
    url: '/forklift/forkliftEventRecord/personWarn',
    method: 'get',
    params
  })
}

// 获取证书分页预警记录
export function getWarnCerPage(params) {
  return request({
    url: '/forklift/driver/page',
    method: 'get',
    params
  })
}

// 字典
export function getDict(type) {
  return request({
    url: '/system/dict/data/type/' + type,
    method: 'get',
  })
}